import { Injectable } from '@angular/core';
import { ReceiptLineItem } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class ReceiptLineItemsService extends BaseService<ReceiptLineItem> {
    constructor() {
        super('ReceiptLineItem');
    }
}
